import React from 'react';
import MainTitle from 'base/components/MainTitle/index';
import Header from 'base/components/Header/index';
import { AppsIcon } from 'base/components/Icon/index';

const NotFound = () => (
  <>
    <Header>
      <MainTitle>
        <AppsIcon />
        {' '}
My spaces
      </MainTitle>
    </Header>
  </>
);

export default NotFound;
